<template lang="html">
  <div>
    <b-row>
      <b-col>
        <DropdownSelectNumber
          :value="overlay.timing_mode"
          :options="timing_mode_slide_number_options"
          label="Overlay timing"
          class="mb-2"
          @changed="v => value_changed('timing_mode', v)"
        />
        <div v-if="overlay.timing_mode == 1">
          <p class="small">
            Appears on
            <b v-text="show.data.slideArray[starting_slide_index].name" />
            <span v-if="overlay.timing_mode == 1">.</span>
          </p>
        </div>
        <div v-if="overlay.timing_mode > 1">
          <p class="small">
            Begins on slide
            <b v-text="show.data.slideArray[starting_slide_index].name" />
            <span v-if="overlay.timing_mode > 1">
              and appears for {{ overlay.timing_mode }} slides.
            </span>
            <span v-if="overlay.timing_mode == 1">.</span>
          </p>
        </div>
        <div v-if="overlay.timing_mode == 0">
          <InputNumber
            :value="overlay.inpoint"
            label="Inpoint"
            @changed="v => value_changed('inpoint', v)"
          />
          <InputNumber
            :value="overlay.duration"
            label="Duration"
            @changed="v => value_changed('duration', v)"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";
import findIndex from "lodash/findIndex";
import DropdownSelectNumber from "./ui/DropdownSelectNumber";
import InputNumber from "./ui/InputNumber";

export default {
  name: "OverlayCommonTimingOptions",
  components: {
    DropdownSelectNumber,
    InputNumber
  },
  props: {
    overlay: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      timing_mode_slide_number_options: [
        { value: 1, text: "Display for one slide only" },
        { value: 2, text: "... 2 slides total" },
        { value: 3, text: "... 3 slides total" },
        { value: 4, text: "... 4 slides total" },
        { value: 5, text: "... 5 slides total" },
        { value: -1, text: "Display on all slides" },
        { value: -10, disabled: true, text: "-------------" },
        { value: 0, text: "Display for specific time range" }
      ]
    };
  },
  computed: {
    show() {
      return this.$store.state.show.currentShow;
    },
    starting_slide_index() {
      return findIndex(this.show.data.slideArray, {
        file: this.overlay.timing_mode_slide_filename
      });
    }
  },
  methods: {
    value_changed(
      property,
      new_value,
      additional_property,
      additional_new_value
    ) {
      console.log("value_changed", property, new_value);
      var overlayObject = cloneDeep(this.overlay);
      overlayObject[property] = new_value;
      if (additional_property) {
        overlayObject[additional_property] = additional_new_value;
      }
      var overlayUnchanged = isEqual(overlayObject, cloneDeep(this.overlay));
      if (!overlayUnchanged) {
        this.$store.dispatch("overlays/updateOverlay", overlayObject);
      }
    }
  }
};
</script>

<style lang="css" scoped></style>
